import { useEffect, useState } from "react";
import { useFetch } from "../../hooks/useFetch";
import { Query } from "../../helpers/querybuilder";
import { Button, Container, Grid } from "@mui/material";
import { downloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import "moment/locale/et";

const UsersWorksheet = () => {
  const { data, loading, fetchData } = useFetch();

  const [volunteers, setVolunteers] = useState(null);

  const fetchVolunteers = () => {
    const query = new Query();
    const url = query
      .for("users")
      .select("id", "name", "last_name", "personal_id")
      .params({ qb: "true", roles: "volunteer" })
      .get();

    fetchData(url);
  };

  useEffect(() => {
    fetchVolunteers();
  }, []);

  useEffect(() => {
    const filteredData = data?.map((volunteer) => {
      const { name, last_name, personal_id } = volunteer;
      return { name: name + " " + last_name, personal_id };
    });

    setVolunteers(filteredData);
  }, [data]);

  const header = ["Nimi", "Isikukood"];

  const handleDownloadExcel = () => {
    const currentDate = moment().format("YY_MM_DD");
    downloadExcel({
      fileName: `${currentDate}_abivajajad.xls`,
      sheet: "Vabatahtlikud",
      tablePayload: {
        header,
        // accept two different data structures
        body: volunteers,
      },
    });
  };

  if (loading) return <p>Laen nimekirja...</p>;

  return (
    <div>
      <Container>
        <Grid paddingY={5}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            Lae vabatahtlike nimekiri alla
          </Button>
        </Grid>
        <Grid>
          <table>
            <thead>
              <tr>
                <td className="w-60 border-1">Nimi</td>
                <td>Isikukood</td>
              </tr>
            </thead>
            <tbody>
              {volunteers.map((volunteer, i) => {
                return (
                  <tr key={i}>
                    <td>{volunteer.name}</td>
                    <td>{volunteer.personal_id}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Grid>
      </Container>
    </div>
  );
};

export default UsersWorksheet;
